module.exports = __webpack_public_path__ + "static/media/start_school_02.dc2a74c4.png";